angular.module("bribac.components.filterIbac", [
    "ui.bootstrap",
    "bribac.translations",
    "bribac.entities.kinds",
    "bribac.services.api",
    "bribac.services.errorUtils",
    "bribac.components.whenLoaded",
    "bribac.components.scheduleDetails"
])

    .component("filterIbac", {
        templateUrl: "filter-ibac-component.html",
        controller: "FilterIbacComponentCtrl",
        bindings: {
            ibac: '=',
            organization: '='
        }
    })

    .controller("FilterIbacComponentCtrl", function(
        api,
        KINDS,
        $scope,
        $translate
    ){
        var $ctrl = this;
        $ctrl.$onInit = function() {
            $ctrl.ibacsPromise = api.getView(KINDS.IBAC).then(function(request) {
                $ctrl.ibacsData = request.data.list
                $ctrl.ibacs = request.data.list
                $ctrl.all = {id: -1, organization: -1,macAddress: $translate.instant('ibacFilter.all', null, "", "", "")}
                $ctrl.ibacs.unshift($ctrl.all)
                if (!$ctrl.ibac) {
                    $ctrl.ibac = $ctrl.ibacs[0]
                }
            }).then(function (){
                $scope.$watch('$ctrl.organization', function (newVal) {
                    if (newVal.id !== -1) {
                        $ctrl.ibacs = $ctrl.ibacsData.filter(function (item) {
                            return item.organization.id === newVal.id
                        })
                        $ctrl.ibacs.unshift($ctrl.all)
                    } else {
                        $ctrl.ibacs = $ctrl.ibacsData
                    }
                    $ctrl.ibac = $ctrl.ibacs[0]
                });
            })
        }
    })
